var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.833459 47.8643C9.05944 50.0684 16.6509 53.2305 24.6654 56.2239C24.7829 56.2554 26.4749 51.3511 25.9225 51.0621C23.4312 49.5486 20.6344 48.2352 17.9198 47.0849C29.2362 45.7464 40.5407 41.1619 50.7875 36.2941C64.7947 29.6139 77.4974 19.3415 84.6179 4.04855C85.1702 2.92761 85.1113 0.796971 85.5578 0.0706685C78.0965 15.6953 64.6418 25.4842 50.1175 31.7438C36.9799 37.529 22.2675 42.6102 8.41269 40.7307C10.0578 39.7616 11.703 38.7925 12.8075 37.9606C16.1213 35.4647 19.3527 32.8058 22.2199 29.6263C22.5959 29.1631 22.4666 27.2956 22.8074 26.9639C18.3068 30.1287 14.053 33.7826 9.38786 36.6213C6.36787 38.4909 3.20683 39.4768 1.8321 43.1972C1.53835 43.8234 0.363403 47.7383 0.833459 47.8643Z"}));
}

ArrowLeft.defaultProps = {"width":"86","height":"57","viewBox":"0 0 86 57"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
